import { subDays, subMonths, format as formatDate } from 'date-fns';

/** props
 * @typedef {Object} Props
 * @property {string} range - The date range to calculate ('week', 'month', 'quarter')
 */
export const getDateRange = (range) => {
  const now = new Date();
  let from;
  if (range === 'week') {
    from = subDays(now, 7);
  } else if (range === 'month') {
    from = subMonths(now, 1);
  } else if (range === 'quarter') {
    from = subMonths(now, 3);
  } else {
    from = subDays(now, 7);
  }
  // Format: 'yyyy-MM-dd HH:mm'
  return {
    from: formatDate(from, 'yyyy-MM-dd 00:00'),
    to: formatDate(now, 'yyyy-MM-dd 23:59'),
  };
};
